var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDoubleThreeQuartsDotOrange(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_12964",
    "data-name": "Group 12964",
    transform: "translate(-524 -2008)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Ellipse_854",
    "data-name": "Ellipse 854",
    transform: "translate(524 2008)",
    fill: "#fff",
    stroke: "#ff8066",
    strokeWidth: 2
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 8,
    cy: 8,
    r: 8,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 8,
    cy: 8,
    r: 7,
    fill: "none"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_9911",
    "data-name": "Path 9911",
    d: "M4,0A4,4,0,1,1,0,4H4Z",
    transform: "translate(528 2012)",
    fill: "#ff8066"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDoubleThreeQuartsDotOrange);
export default __webpack_public_path__ + "static/media/DoubleThreeQuartsDotOrange.40c305e8359e39a29b99b1ad63b59008.svg";
export { ForwardRef as ReactComponent };